import { render, staticRenderFns } from "./InboxSidebar.vue?vue&type=template&id=6adee46c&scoped=true&"
import script from "./InboxSidebar.vue?vue&type=script&lang=js&"
export * from "./InboxSidebar.vue?vue&type=script&lang=js&"
import style0 from "./InboxSidebar.vue?vue&type=style&index=0&id=6adee46c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adee46c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6adee46c')) {
      api.createRecord('6adee46c', component.options)
    } else {
      api.reload('6adee46c', component.options)
    }
    module.hot.accept("./InboxSidebar.vue?vue&type=template&id=6adee46c&scoped=true&", function () {
      api.rerender('6adee46c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TeamInbox/InboxSidebar.vue"
export default component.exports